import { capitalize as lodashCapitalize, startCase } from 'lodash-es'
/* eslint-disable */
import { SAPPTrackingEvent, SAPPTrackingEventName } from '~/types/sapp-track'
import {
  NO_CREDIBILITY_BANNER,
  LIMITED_BLURRED_CARDS,
  LIMITED_CONTROL,
  LIMITED_NO_APPLICATION, CREDIBILITY_BANNER
} from '~/plugins/feature-flags/variants'

export const getKeys = Object.keys as <T extends object>(obj: T) => Array<keyof T>

export const isMobile = () => {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i
  ];

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
}

export const capitalizeFirstChar = (string: string) => (string.substring(0, 1).toUpperCase() + string.substring(1));

export const capitalize = (string: string) => {
  return string
    .toLowerCase()
    .trim()
    .split(' ')
    .map(capitalizeFirstChar)
    .join(' ');
};

export const gcd = (x:number, y:number) => {
  x = Math.abs(x);
  y = Math.abs(y);
  while(y) {
    const t = y;
    y = x % y;
    x = t;
  }
  return x;
}

export const debounce = (timeoutHolder => {
  const clear = () => window.clearTimeout(timeoutHolder);

  return (callback: () => void, timeout = 300) => {
    if(timeoutHolder) clear();

    // @ts-ignore
    timeoutHolder = window.setTimeout(() => {
      if(callback) callback();
    }, timeout);

    return clear;
  };
})();

export const notifyUnloadFunc = (event) => {
  const e = event || window.event
  e.preventDefault()
  if (e) {
    e.returnValue = ''
  }
  return ''
}
export const idleCallback = (callback: () => void) => {
  const timeout = 3000;
  if (window.requestIdleCallback) {
    window.requestIdleCallback(() => {
      callback();
    }, {timeout});
  } else {
    callback();
  }
};

type WaitUntilResolve = <T>(promise: Promise<T>, timeOut: number) => Promise<T>
export const waitUntilResolve:WaitUntilResolve = (promise, timeOut = 3000) => {
  return new Promise((resolve, reject) => {
    const timeout = setTimeout(() => reject(Error('Timeout expired')), timeOut)

    promise
      .then(r => resolve(r))
      .catch(err => reject(err))
      .finally(() => clearTimeout(timeout))
  })
}

type WaitMinimum = <T>(promise: Promise<T>, timeOut: number) => Promise<T>
export const waitMinimum: WaitMinimum = (promise, timeOut = 3000) => {
  return new Promise((resolve, reject) => {
    const handler = () => promise.then(r => resolve(r)).catch(e => reject(e))
    setTimeout(handler, timeOut)
  })
}

export const randomString = (n = 16) => {
  let text = '';
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz012345678';

  for(let i=0; i < n; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
};

export const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent)

export const getTabName = (route) => {
  if (!route.fullPath.includes('scholarships')) { return '' }
  return route.fullPath.split('/')[2] ? route.fullPath.split('/')[2] : ''
}

interface InjectScriptParams {
  success?: () => void;
  error?: () => void;
  id?: string;
  src: string
}

export const injectScript = ({ success, error, id, src }: InjectScriptParams) => {
  const script = document.createElement('script')

  if (id) { script.id = id }
  script.onload = success
  script.onerror = error

  script.src = src

  const scripts = document.getElementsByTagName('script')

  if (scripts.length) {
    const lastScriptNode = scripts[scripts.length - 1]
    lastScriptNode.parentNode.insertBefore(script, lastScriptNode)
  } else {
    document.body.appendChild(script)
  }
}

export const objectToArray = object => {
  if(typeof object !== 'object' || object === null)
    throw Error('Please provide object');

  return Object.keys(object).map(key => {
    return object[key];
  });
};


export const elementWidth = (itemCount, parentWidth?) => {
  if(!itemCount) throw Error('Please provide item count!');

  let units = 'px';

  if(!parentWidth) {
    units = '%';
    parentWidth = 100;
  }

  return `${Math.round(parentWidth / itemCount)}${units}`;
};

export const shallowObjectCopy = object => JSON.parse(JSON.stringify(object));

export const trackScholarship = (data: SAPPTrackingEvent) => {
  const isProd = process.env.NODE_ENV === 'production'
  const timer = setInterval(() => {
    if (window.sapp) {
      window.sapp.track(data)
      if (!isProd || window.qaDebug) {
        console.log(`sapp.track(${JSON.stringify(data)})`)
      }
      clearInterval(timer)
    }
  }, 50)
}

export const getSappTrackingData = (eventName: SAPPTrackingEventName, sid: string, said: string): SAPPTrackingEvent => {
  const eventMapping: { [key: string]: SAPPTrackingEvent } = {
    visit: { sid, said, source: 'sowl', event: 'visit' },
    saved: { sid, said, source: 'sowl', event: 'saved' },
    ignored: { sid, said, source: 'sowl', event: 'ignored' },
    started: { sid, said, source: 'sowl', event: 'started' },
    impression: { sid, said, source: 'sowl', event: 'impression' },
    applied: { sid, said, source: 'sowl', event: 'applied' },
    ['goal-click']: { sid, said, source: 'sowl', event: 'goal-click' }
  }
  return eventMapping[eventName]
}
export const getFreemiumLimitedMixpanelValueNames = (feature: string): string => {
  if (feature === LIMITED_NO_APPLICATION) {
    return 'No application';
  } else if (feature === LIMITED_BLURRED_CARDS) {
    return 'Blurred cards';
  } else if (feature !== LIMITED_CONTROL) {
    return 'Disabled'
  } else {
    return 'Control'
  }
}

export const getFreemiumCredibilityMixpanelValueNames = (feature: string): string => {
  if (feature === CREDIBILITY_BANNER) {
    return 'Credibility banner';
  } else if (feature === NO_CREDIBILITY_BANNER) {
    return 'No credibility banner';
  } else {
    return 'Disabled'
  }
}

export const getMxFormattedVariant = (variant: string): string => {
  return lodashCapitalize(startCase(variant))
}

export const getCredibilityScoreValue = (confidenceScore: number): string => {
  const isVerifiedScholarship = confidenceScore == 100
  const isLowCredibilityScholarship = confidenceScore <= 35
  const isHighCredibilityScholarship = confidenceScore >= 70
  if(isVerifiedScholarship) {
    return 'verified'
  }
  else if(isLowCredibilityScholarship) {
    return 'low'
  }
  else if(isHighCredibilityScholarship){
    return 'high'
  }
  return  'medium'
}

export const getFreemiumStatusesMixpanelValueNames = (variant: string): string => {
  if (variant === 'enabled') {
    return 'Statuses unlocked'
  }
  return 'No statuses'
}

export const manageWidgets = (disable: boolean): void => {
  // Manage Intercom visibility
  const hasDisableClass = document.querySelector('.disable-intercom')
  if (disable && !hasDisableClass) {
    document.body.classList.add('disable-intercom')
  } else if (!disable && hasDisableClass) {
    document.body.classList.remove('disable-intercom')
  }

  // Manage feedback widget visibility
  const feedbackWidget = document.querySelector('[data-testid="survey-root"]') as HTMLElement
  if (feedbackWidget) {
    feedbackWidget.style.display = disable ? 'none' : 'block'
  }
}

export function exponentialBackoff<T>(
  fn: () => Promise<T>,
  retries: number,
  delay: number,
  maxDelay: number
): { promise: Promise<T>; abortController: AbortController } {
  const controller = new AbortController()
  const { signal } = controller

  const promise = (async() => {
    let attempt = 0

    while (attempt < retries) {
      if (signal.aborted) {
        throw new Error('Operation aborted')
      }

      try {
        return await fn()
      } catch (error) {
        attempt++
        if (attempt >= retries) {
          throw error
        }

        const backoffDelay = Math.min(delay * Math.pow(2, attempt), maxDelay)

        await new Promise((resolve, reject) => {
          const timeout = setTimeout(resolve, backoffDelay)

          signal.addEventListener(
            'abort',
            () => {
              clearTimeout(timeout)
              reject(new Error('Operation aborted during delay'))
            },
            { once: true }
          )
        })
      }
    }

    throw new Error('Function failed after all retries')
  })()

  return { promise, abortController: controller }
}
